import { render, staticRenderFns } from "./Hotness.vue?vue&type=template&id=1a2f86c3&lang=pug"
import script from "./Hotness.vue?vue&type=script&lang=js"
export * from "./Hotness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports